import React from "react";
import {Redirect, Route, Router, Switch} from "react-router-dom";
import {connect} from "react-redux";
import {history, seguirCanonica} from "../_helpers";
import {userActions} from "../_actions";
import {CompletarCelular, LoginPage, LogoutPage, PrivateRoute, RegisterPage} from "../_components/general";
import {NavBar} from "../_components/includes";
import {Listador} from "../_components/publica/Listador";
import {Bajas} from "../_components/publica/Bajas";
import {ProductosVendedorList} from "../_components/vendedor/productos/ProductosVendedorList";
import {Dashboard} from "../_components/vendedor/Dashboard";
import {VentasList} from "../_components/vendedor/ventas/VentasList";

import {MiPerfil} from "../_components/vendedor/MiPerfil";
import {ProductDetail} from "../_components/publica/ProductDetail";
import {library} from "@fortawesome/fontawesome-svg-core";
import {fab} from "@fortawesome/free-brands-svg-icons";
import {fas} from "@fortawesome/free-solid-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";
import {CheckoutPage} from "../_components/publica/Checkout";
import {FormProducto} from "../_components/vendedor/productos/FormProducto";
import {FormRepuestoDeBaja} from "../_components/vendedor/productos/FormRepuestoDeBaja";
import authService from "../_services/cart/authService";
import {ComprasList} from "../_components/vendedor/ventas/ComprasList ";
import {MiPerfilComprador} from "../_components/vendedor/MiPerfilComprador";
import {CompraDetail} from "../_components/vendedor/ventas/utils/CompraDetail";
import {VendedorDetail} from "../_components/publica/VendedorDetail";
import Footer from "../_components/includes/Footer";

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import {UsuariosList} from "../_components/admin/UsuariosList";
import {UsuarioDetail} from "../_components/admin/utils/UsuarioDetail";
import {MarcaTiposList} from "../_components/admin/MarcaTiposList";
import {GoogleOAuthProvider} from "@react-oauth/google";
import {TerminosCondiciones} from "../_components/publica/TerminosCondiciones";
import {VentasAdminList} from "../_components/admin/VentasAdminList";
import {ConsultasAdminList} from "../_components/admin/ConsultasAdminList";
import {PublicacionesAdminList} from "../_components/admin/PublicacionesAdminList";
import {MiPerfilAdmin} from "../_components/admin/MiPerfilAdmin";
import {SobreNosotros} from "../_components/publica/SobreNosotros";
import {ConsultaDetail} from "../_components/admin/utils/ConsultaDetail";
import {MpModal} from "../_components/vendedor/MpModal";
import {PoliticaPrivacidad} from "../_components/publica/PoliticaPrivacidad";
import { MpModalComision } from "../_components/vendedor/MpModalComision";
import { AlertasList } from "../_components/vendedor/AlertasList";
import { Demanda } from "../_components/vendedor/Demanda";
import { OfertasList } from "../_components/vendedor/ofertas/OfertasList";
import { UsuariosCuenta } from "../_components/vendedor/cuenta/UsuariosCuenta";
import { MiPlan } from "../_components/vendedor/cuenta/MiPlan";
import { ArcaIntegracion } from "../_components/vendedor/cuenta/ArcaIntegracion";
import { FacturasCuenta } from "../_components/vendedor/cuenta/FacturasCuenta";
import { CheckoutSuscripcion } from "../_components/vendedor/cuenta/CheckoutSuscripcion";
import { SuscripcionOk } from "../_components/vendedor/cuenta/SuscripcionOk";
import { Planes } from "../_components/publica/Planes";
import { SuscripcionesAdmin } from "../_components/admin/SuscripcionesAdmin";
import { Mensajes } from "../_components/mensajes/Mensajes";
import { MensajesPanel } from "../_components/mensajes/MensajesPanel";

const publicURL = process.env.PUBLIC_URL;

class App extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {};

    componentDidMount() {
        if (authService.isAuthenticated()) {
            this.props.getLogueado();
        }

        history.listen((location, action) => {
            this.setState({rerender: true});
        });

        seguirCanonica(history);
    }

    mostrarNavBar = () => {
        let {pathname} = history.location;

        pathname = pathname.substring(
            pathname.indexOf("/"),
            pathname.lastIndexOf("/")
        );

        return pathname !== '/vendedor' && pathname !== '/comprador' && pathname !== '/admin' && pathname !== '/perfil';
    }

    render() {
        const {user} = this.props;
        const {rerender} = this.state;

        return (
            <div className="wrapper__main">
                <GoogleOAuthProvider
                    clientId="142122613125-l8oi6r2a5t4bqlvfafnk193iovvteq1h.apps.googleusercontent.com">
                    <Router history={history} basename={publicURL}>
                        {this.mostrarNavBar(history) && <NavBar/>}

                        <ToastContainer/>
                        <Switch>
                            <Route exact path="/sobre-nosotros" component={SobreNosotros}/>
                            <Route exact path="/politica-privacidad" component={PoliticaPrivacidad}/>
                            <Route exact path="/terminos-condiciones" component={TerminosCondiciones}/>
                            <Route exact path="/checkout" component={CheckoutPage}/>
                            <Route exact path="/home" component={Listador}/>
                            <Route exact path="/" component={Listador}/>
                            <Route exact path="/busqueda" component={Listador}/>
                            <Route exact path="/bajas" component={Bajas}/>
                            <Route exact path="/login" component={LoginPage}/>
                            <Route exact path="/register" component={RegisterPage}/>
                            {/* El link de alta para vendedores: queda vendiendo, con su cuenta y la prueba gratis. */}
                            <Route exact path="/registro-vendedor" render={(props) => <RegisterPage {...props} vendedor/>}/>
                            <Route exact path="/planes" component={Planes}/>
                            <Route exact path="/logout" component={LogoutPage}/>
                            {/* URL canonica; la vieja se conserva porque hay links compartidos */}
                            <Route exact path="/producto/:slug" component={ProductDetail}/>
                            <Route exact path="/productDetail" component={ProductDetail}/>
                            {/* Canonica de la tienda; /vendedorDetail?id=N queda por los links ya compartidos. */}
                            <Route exact path="/tienda/:slug" component={VendedorDetail}/>
                            {/*
                                El catalogo de una tienda es el mismo Listador con el filtro de
                                vendedor puesto. Tiene URL propia —y con el nombre adentro— para que
                                el vendedor la comparta en sus redes; /busqueda?vendedor=N sigue
                                funcionando y es a donde caen los links viejos.
                            */}
                            <Route exact path="/tienda/:slug/catalogo" component={Listador}/>
                            <Route exact path="/vendedorDetail" component={VendedorDetail}/>
                            {/*
                                Paginas de categoria (SEO): el mismo Listador con los filtros
                                sembrados desde la URL. Los bots reciben el prerender del backend
                                (CatalogoSeoController); ver _helpers/categorias.js.
                            */}
                            <Route exact path="/repuestos/:tipo/:marca?" component={Listador}/>
                            <Route exact path="/autopartes-usadas/:marca/:modelo?" component={Listador}/>

                            <PrivateRoute exact path="/vendedor/dashboard" component={Dashboard}/>
                            <PrivateRoute exact path="/vendedor/productos" component={ProductosVendedorList}/>
                            <PrivateRoute exact path="/vendedor/ventas" component={VentasList}/>
                            <PrivateRoute exact path="/vendedor/ofertas" component={OfertasList}/>
                            <PrivateRoute exact path="/vendedor/usuarios" component={UsuariosCuenta}/>
                            <PrivateRoute exact path="/vendedor/plan" component={MiPlan}/>
                            <PrivateRoute exact path="/vendedor/arca" component={ArcaIntegracion}/>
                            <PrivateRoute exact path="/vendedor/facturas" component={FacturasCuenta}/>
                            <PrivateRoute exact path="/vendedor/suscripcion/checkout/:planId" component={CheckoutSuscripcion}/>
                            <PrivateRoute exact path="/vendedor/suscripcion/ok" component={SuscripcionOk}/>
                            <PrivateRoute exact path="/vendedor/miPerfil" component={MiPerfil}/>
                            <PrivateRoute exact path="/vendedor/miMp" component={MpModal}/>
                            <PrivateRoute exact path="/vendedor/miMpComision" component={MpModalComision}/>
                            {/* Demanda del sitio: la ven vendedores y admins por igual, de ahi que
                                cuelgue de /vendedor y no de /admin. Quien puede entrar lo decide el
                                @PreAuthorize del DemandaController, no esta ruta. */}
                            <PrivateRoute exact path="/vendedor/demanda" component={Demanda}/>
                            
                            <PrivateRoute exact path="/vendedor/addEditProducto" component={FormProducto}/>
                            <PrivateRoute exact path="/vendedor/nuevoProductoDeBaja" component={FormRepuestoDeBaja}/>

                            <PrivateRoute exact path="/comprador/compraDetail" component={CompraDetail}/>
                            <PrivateRoute exact path="/comprador/misCompras" component={ComprasList}/>
                            <PrivateRoute exact path="/comprador/miPerfil" component={MiPerfilComprador}/>
                            <PrivateRoute exact path="/perfil/alertas" component={AlertasList}/>
                            {/* El centro de mensajes es uno solo para los dos lados: el mismo usuario
                                compra en un hilo y vende en otro. Vive fuera de /vendedor y de
                                /comprador porque mostrarNavBar() esconde el header en esos prefijos, y
                                el chat necesita el globo del header a la vista. */}
                            <PrivateRoute exact path="/mensajes" component={Mensajes}/>
                            {/* El mismo chat pero con el menu lateral: es a donde lleva
                                "Mensajes" desde el panel. Ver MensajesPanel. */}
                            <PrivateRoute exact path="/perfil/mensajes" component={MensajesPanel}/>

                            <PrivateRoute exact path="/admin/miPerfil" component={MiPerfilAdmin}/>
                            <PrivateRoute exact path="/admin/usuarios" component={UsuariosList}/>
                            <PrivateRoute exact path="/admin/suscripciones" component={SuscripcionesAdmin}/>
                            <PrivateRoute exact path="/admin/tipos" component={MarcaTiposList}/>
                            <PrivateRoute exact path="/admin/userDetail" component={UsuarioDetail}/>
                            <PrivateRoute exact path="/admin/consultaDetail" component={ConsultaDetail}/>
                            <PrivateRoute exact path="/admin/ventas" component={VentasAdminList}/>
                            <PrivateRoute exact path="/admin/consultas" component={ConsultasAdminList}/>
                            {/* Mismos formularios que el vendedor, pero en modo back office:
                                FormProducto/FormRepuestoDeBaja miran la ruta para saberlo. */}
                            <PrivateRoute exact path="/admin/publicaciones" component={PublicacionesAdminList}/>
                            <PrivateRoute exact path="/admin/addEditProducto" component={FormProducto}/>
                            <PrivateRoute exact path="/admin/nuevoProductoDeBaja" component={FormRepuestoDeBaja}/>
                            <Redirect from="*" to="/"/>
                        </Switch>
                        {this.mostrarNavBar(history) && <Footer/>}

                        {/* Fuera del Switch: la cuenta sin celular tiene que completarlo esté donde
                            esté, no sólo si pasa por una pantalla en particular. */}
                        <CompletarCelular/>
                    </Router>
                </GoogleOAuthProvider>
            </div>
        );
    }
}

function mapState(state) {
    const {authentication} = state;
    const {user} = authentication;
    return {user};
}

const actionCreators = {
    getLogueado: userActions.getLogueado
};

const connectedApp = connect(mapState, actionCreators)(App);
export {connectedApp as App};

library.add(fab, fas, far);
